<template>
    <div>
        <div style="display:flex; align-items: baseline;margin-bottom: 20px">
            <h2>付费记录</h2>
            <span style="margin-left: 20px;">用户id：{{ userData.userId }}</span>
        </div>
        <div style="padding: 0 20px;" v-if="userData.colorationType==0||this.userData.colorationType==3">
          <div style="display:flex; align-items: baseline;margin-bottom: 20px;">
                <h3>累计付费（美元）：{{ wallet.balanceNum }}</h3>
            </div>
            <Table :columns="columns1" :data="tableData1">
            <Pages slot="footer" :page="page" :func="findData"></Pages>

            </Table>
        </div>

        <div v-else>
          <div style="padding: 0 20px;" v-for="(item,index) in data" :key="index">
            <div style="display:flex; align-items: baseline;margin-bottom: 20px;">
                  <h3>{{ item.title }}</h3>
                  <h3 style="margin-left: 20px">累计付费（美元）：{{ item.totalPay }}</h3>
                  <h3 style="margin-left: 20px">累计付费次数：{{ item.totalPayCount }}</h3>
                  <h3 style="margin-left: 20px">染色时间戳：{{ item.colorationTime }}</h3>
              </div>
              <Table :columns="columns1" :data="item.userPayList">

              </Table>
          </div>
        </div>

    </div>
</template>

<script>
import Pages from '@/components/pages'
import { getUserPayList, getUserPayListColor } from '@/api/user'
export default {
  components: {
    Pages
  },
  props:{
    userData: {
      type: Object,
      default: () => ({})
    },
    wallet: {}
  },
  data() {
    return {
      page:{
        current: 1,
        size: 10,
        total: 0
      },
      data: [],
      tableData1:[],
      columns1: [
        {
          title:'订单号',
          key: 'orderNo'
        },
        {
          title:'付费项id',
          key: 'goodsId'
        },
        {
          key: 'goodsName',
          title:'付费项名称'
        },
        {
          key: 'goodsTypeName',
          title:'付费类型'
        },
        {
          key: 'goodsPrice',
          title:'支付费用（美元）'
        },
        {
          key: 'payStatusName',
          title:'支付状态'
        },
        {
          key: 'createTimeFmt',
          title:'创建时间'
        },
        {
          key: 'payTimeFmt',
          title:'支付时间'
        }

      ]
    }
  },
  methods: {
    findData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      getUserPayList({
        ...this.page,
        userId:this.userData.userId
      }).then(({ data }) => {
        this.tableData1 = data.records
        this.page.total = data.total
      })
    },
    getColorData(){
      getUserPayListColor({
        current: -1,
        size: -1,
        userId:this.userData.id
      }).then(({ data }) => {
        this.data = data.records.map((i,index)=>{
          return {
            ...i,
            title: index?'重染色'+index:'首次染色'
          }
        })
        this.data.reverse()
        this.page.total = data.total
      })
    }
  },
  mounted() {
    if(this.userData.colorationType==0||this.userData.colorationType==3){
      this.findData()
      // this.getColorData()
    }else
    this.getColorData()
  }
}
</script>
